<template>
  <v-dialog v-model="dialog" v-if="dialog" max-width=600 scrollable>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Add Shipping Information
      </v-card-title>
      <v-card-text>
        <v-checkbox label="Make this the default Shipping Address" v-model="address.default"></v-checkbox>
        <contact-input
          :showResCheckBox="true"
          :contact="address"
          @update-contact="$emit('update', $event)"
        />
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn color="primary" @click="$emit('save', address)">Save</v-btn>
        <v-btn flat @click="$emit('close')">Cancel</v-btn>
        <v-spacer/>
        <v-btn flat color='red' @click="$emit('delete', address.id)">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ContactInput from '../widgets/contact-input'

export default {
  components: {
    'contact-input': ContactInput
  },

  props: {
    address: Object,
    value: Boolean
  },

  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        if (value === false) this.$emit('close')
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// shipping-address-form.vue?f1c3fa68